import IndexSocial from './IndexSocial'

export default IndexSocial
